export const DateHelper = {
    formatDateTime(dateString: string) {
        const date = new Date(dateString);

        //Format as d mmm yyyy h:mm AM/PM
        const formattedDate = date.toLocaleString("en-SG", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true, // 12-hour format with AM/PM
        }).replace(",", " |")

        return formattedDate;
    },
    formatLongDateTime(dateString: string) {
        const date = new Date(dateString);

        //Format as d mmm yyyy h:mm AM/PM
        const formattedDate = date.toLocaleString("en-SG", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true, // 12-hour format with AM/PM
        }).replace(",", " ")

        return formattedDate;
    },
    formatDate(dateString: string) {
        const date = new Date(dateString);

        //Format as d mmm yyyy
        const formattedDate = date.toLocaleString("en-SG", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });

        return formattedDate;
    },

    formatDateNumeric(dateString: string) {
        const date = new Date(dateString);

        //Format as d mmm yyyy
        const formattedDate = date.toLocaleString("en-SG", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        });

        return formattedDate;
    },
    dateSubtractDays(date: Date, d: number): Date {
        const inputDate = new Date(date);
        const dateResult = new Date();
        dateResult.setTime(inputDate.getTime() 
            - (d * 24 * 60 * 60 * 1000));
        return dateResult;
    }
};